import { Expose } from "@nts/std/serialization";

export class UIFinderJS {
    @Expose()
    url: string;
}
